import { DOCUMENT, Location, PlatformLocation } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { WishlistService } from '@app/app/wishlist/wishlist.service';
import { carouselEnum } from '@app/components/carousel/iCarousel';
import {
  CacheObjectService,
  DeviceService,
  EventTrackerService,
  HttpService,
  LogService,
  TypeShowLogInConsole
} from '@app/core';
import { TokenService } from '@app/core/token/token.service';
import { ScrollToLastPosition } from '@app/helper/scroll-to-last-position';
import { iBook, ProductTypeEnum } from '@app/interfaces/iBook';
import { iProduct } from '@app/interfaces/IProduct';
import { iRating } from '@app/interfaces/iRating';
import { IndicatorService } from '@app/shared';
import { NotificationService } from '@app/shared/notification/notification.service';
import { environment } from '@env/environment';
import { Subject, Subscription, SubscriptionLike } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { PdpDialogMarketsComponent } from '../pdp-dialog-markets/pdp-dialog-markets.component';
import {
  IPurchase,
  libraryTransitionType,
  ListArtistModel,
  ProductComment,
  subscriptionButtonStateType
} from '../pdp-model';
import { PDPService } from './pdp.service';
import { BROADCAST_SERVICE } from '@app/config.app';
import { BroadcastService } from '@app/helper/broadcast-message';
import { AppParametersService } from '@app/core/token/app-parameters.service';
import { ClientTypeEnum } from '@app/helper/ClientTypeEnum';

@Component({
  selector: 'navaar-pdp',
  templateUrl: './pdp.component.html',
  styleUrls: ['./pdp.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdpComponent extends ScrollToLastPosition implements OnInit, OnDestroy {
  public subscription: Subscription = new Subscription();
  public isShowRate: boolean = false;
  public ratoToComment: number = 0;
  public dataBook: iBook;
  public product: iProduct;
  public isShowDescription: boolean = false;
  public recommendData: any;
  public purchase: IPurchase;
  public recomendation: any;
  private audiobookId: Subject<any> = new Subject<any>();
  private pendingRequest: Subscription;
  private stateAudiobookRequest: Subscription;
  public productId: any;
  public environment = environment;
  public artistList: Array<ListArtistModel> = [];
  public productType: typeof ProductTypeEnum = ProductTypeEnum;
  public libraryTransitionType: typeof libraryTransitionType = libraryTransitionType;
  public infoEpisod: { count?: number, title?: string, genreId?: number } = {count: 0, title: '', genreId: 0};
  public comment: Array<ProductComment> = [];
  public rate: iRating;
  public totalCountComment: number;
  public showPopupDownload: boolean = false;
  public hasInWishlist: boolean;
  public inProcessToAddWishlist: boolean = false;
  private id: any;
  public loadComplete: boolean = false;
  public isLogin: boolean = false;
  private _locationObserve: SubscriptionLike;
  public carouselType: typeof carouselEnum = carouselEnum;
  public image: string | null = null;
  private subscriptionParam: Subscription = new Subscription();
  private broadcastBrowserSubscription: Subscription = new Subscription();
  public clientTypeEnum: typeof ClientTypeEnum = ClientTypeEnum;

  @ViewChild('containerMarkets', {read: ViewContainerRef}) private containerMarkets: ViewContainerRef;

  constructor(
    @Inject(BROADCAST_SERVICE) private readonly broadCastService: BroadcastService,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly resolver: ComponentFactoryResolver,
    private readonly platformLocation: PlatformLocation,
    private readonly location: Location,
    private readonly wishListService: WishlistService,
    private readonly notification: NotificationService,
    private readonly render: Renderer2,
    private readonly eventTracker: EventTrackerService,
    private readonly chkd: ChangeDetectorRef,
    public readonly device: DeviceService,
    private readonly log: LogService,
    private readonly indicator: IndicatorService,
    private readonly cache: CacheObjectService<any>,
    private readonly http: HttpService,
    private readonly router: Router,
    public readonly pdpService: PDPService,
    public readonly tokenServices: TokenService,
    public readonly parametersService: AppParametersService,
    private readonly route: ActivatedRoute) {
    super(router);
    this.subscription.add(this.router.events
      .pipe(filter((event) => event instanceof NavigationStart || event instanceof NavigationEnd))
      .subscribe((event: NavigationStart | NavigationEnd) => {
        if (event instanceof NavigationStart && event.restoredState)
          this.pdpService.isBackFromItem = true;
      }));
    if (this.device.isAndroid() || this.device.isIOS()) {
      this.router.routeReuseStrategy.shouldReuseRoute = (f, c) => {
        if (this.router.getCurrentNavigation()?.extractedUrl?.fragment === 'modalOpened')
          return true;
        if (Object.values(this.router.getCurrentNavigation()?.extractedUrl?.queryParams)?.length > 0)
          return false;
        if (c.paramMap.get('id') == null && f.paramMap.get('id') == null)
          return true;
        const result = c.paramMap.get('id') != null && f.paramMap.get('id') != null && c.paramMap.get('id') == f.paramMap.get('id');
        if (result)
          this.indicator.hide();
        return result;
      };
    }
    this.device.hide();
  }

  public ngOnInit() {
    if (this.device.isPwa() || this.device.isDevelop()) {
      this.broadcastBrowserSubscription = this.broadCastService.messagesOfType('buy-pdp-return-auth-redirect').subscribe(message => {
        console.log('%c message from auth redirect: ' + JSON.stringify(message), 'background: #222; color: #bada55; font-size: 24px')
        if (message.payload?.productId == this.dataBook.products[0]['productId'] && message.payload?.isSuccess == true) {
          this.refreshStatePurchase();
        }
      });
    }
    this._locationObserve = this.location.subscribe(c => {
      this.initialing();
    });
    this.subscriptionParam = this.route.paramMap.subscribe(c => {
      this.chkd.markForCheck();
      if (this.stateAudiobookRequest)
        this.stateAudiobookRequest.unsubscribe();
      this.loadComplete = false;
      this.indicator.hide();
      this.artistList = [];
      this.recommendData = [];
      this.recomendation = [];
      this.dataBook = null;
      this.indicator.show();
      this.id = +this.route.snapshot.paramMap.get('id');
      this.audiobookId.next(this.id);
      this.cache.getObjectCache(`/api/audiobooks/${this.id}/detail2`).subscribe(x => {
        this.dataBook = x;
        this.image = environment.imageUrl + '/content/books/' + x.audioBookId + '/pic.jpg?t=' + x.recordVersion + '&w=512&h=512';
        this.productId = this.dataBook.products[0]['productId'];
        this.product = this.dataBook.products[0];
        this.stateAudiobookRequest = this.tokenServices.isLogin$.subscribe(c => {
          this.isLogin = c;
          if (this.isLogin) {
            this.refreshStatePurchase();
          } else {
            this.rate = this.dataBook.rating;
            this.ratoToComment = this.rate.userRate ?? 0;
          }
        });
        this.dataBook.authors.forEach(c => {
          this.artistList.push({
            description: c.shortDescription,
            id: c.artistId,
            image: c.imageUrl ? c.imageUrl : 'assets/icon-new/user-empty.svg',
            name: `${c.firstName} ${c.lastName}`,
            title: 'نویسنده',
            artistId: c.artistId,
            recordVersion: c.recordVersion
          })
        })
        this.dataBook.narrators.forEach(c => {
          this.artistList.push({
            description: c.shortDescription,
            id: c.artistId,
            image: c.imageUrl ? c.imageUrl : 'assets/icon-new/user-empty.svg',
            name: `${c.firstName} ${c.lastName}`,
            title: 'گوینده',
            artistId: c.artistId,
            recordVersion: c.recordVersion
          })
        })
        this.dataBook.translators.forEach(c => {
          this.artistList.push({
            description: c.shortDescription,
            id: c.artistId,
            image: c.imageUrl ? c.imageUrl : 'assets/icon-new/user-empty.svg',
            name: `${c.firstName} ${c.lastName}`,
            title: 'مترجم',
            artistId: c.artistId,
            recordVersion: c.recordVersion
          })
        })
        this.getRecommendation();
        this.getComments();
        this.infoEpisods();

        this.loadComplete = true;
        if (this.pdpService.isBackFromItem) {
          super.scrollToPosition();
        }
        this.chkd.detectChanges();
      });
    });
  }

  private initialing() {
    this.isShowDescription = false;
    this.showPopupDownload = false;
    this.isShowRate = false;
    this.render.removeStyle(this.document.body, 'overflow');
    this.chkd.markForCheck();
  }

  public setBackground(image) {
    if (image)
      return `url(${image})`
  }

  public rateToItem(e) {
  }

  public goToComment() {
    this.indicator.show();
    this.logItem('x_btn_go_to_comments', {
      item_id: this.dataBook.identifier,
      title: this.dataBook.title,
      'count-comment': this.totalCountComment
    });
    this.router.navigate(['audiobook', 'comment', this.dataBook.audioBookId, this.id], {queryParams: {title: this.dataBook.title}}).then();
  }

  private getComments() {
    this.cache.postObjectCache(`/api/ratereview/Get/${this.id}?$top=2&$inlinecount=allpages`).subscribe(c => {
      this.comment = c.items;
      this.totalCountComment = c.count;
      this.chkd.detectChanges();
    })
  }

  public getTitleAgetsList(contentType: ProductTypeEnum): string {
    switch (contentType) {
      case ProductTypeEnum.AudioBook:
      case ProductTypeEnum.Capsule:
        return 'عوامل'
      case ProductTypeEnum.AudioSeries:
        return 'بازیگران'
    }
  }

  private getRecommendBooks() {
    this.recomendation = [];
    this.recommendData = [];
    const url = `/api/audiobooks/recommend/${this.id}?$top=6`;
    this.cache.getObjectCache(url).subscribe(c => {
      this.recommendData = c;
      this.chkd.detectChanges();
    });
  }

  private getRecommendation() {
    this.recomendation = [];
    this.recommendData = [];
    this.pendingRequest = this.cache.getObjectCache("/api/audiobooks/recommendation/" + this.id + "?$top=6")
      .pipe(takeUntil(this.audiobookId))
      .subscribe(c => {
        const items: Array<any> = c['items'];
        if (items.length > 0) {
          items.forEach(c => {
            let _ = c.audioBooks;
            this.recomendation.push({
              title: c.title,
              items: _,
              code: c.code,
              listApi: c.listApi
            });
          })
          this.chkd.detectChanges();
        } else {
          this.getRecommendBooks();
        }
      }, (err) => {
        this.getRecommendBooks();
      })
    this.cache.getObjectCache("/api/audiobooks/view/" + this.id, `view-recommendation--${this.id}`).subscribe(c => {
      this.log.logger('view registered!!!');
    })
  }

  public share() {
    this.logItem('x_btn_share_from_web', {});
    this.device.share(this.dataBook.identifier, this.dataBook.title);
  }

  public sendViaGift() {
    this.logItem('x_btn_send_gift', {});
  }

  public async toggleWishlist(status) {
    if (!this.isLogin) {
      this.device.goTologinPageNative('pdp/' + this.dataBook.identifier);
      return;
    }
    if (this.inProcessToAddWishlist)
      return;
    if (!this.device.checkToolsVersionSupport()) {
      this.notification.setNotification({
        text: 'برای استفاده از این قابلیت ، اپلیکیشن خود را بروزرسانی کنید',
        type: 'error',
        timeout: 5000
      });
      return;
    } else {
      this.inProcessToAddWishlist = true;
      if (status) {
        this.logItem('x_btn_toggle_wishlist', {
          status: 'add'
        });
        await this.wishListService.addToWishlist({productId: this.dataBook.products[0].productId}).toPromise().then((res: any) => {
          this.notification.setNotification({text: 'به لیست نشان شده‌ها اضافه شد', type: 'info'});
          this.hasInWishlist = true;
        }, err => {
          this.notification.setNotification({text: 'خطایی رخ داد. لطفا دوباره تلاش کنید', type: 'error'});
        });
      } else {
        this.logItem('x_btn_toggle_wishlist', {
          status: 'remove'
        });
        await this.wishListService.removeItem({productId: this.dataBook.products[0].productId}).toPromise().then((res: any) => {
          this.notification.setNotification({text: 'از لیست نشان شده‌ها حذف شد.', type: 'info'});
          this.hasInWishlist = false;
        }, err => {
          this.notification.setNotification({text: 'خطایی رخ داد. لطفا دوباره تلاش کنید', type: 'error'});
        });
      }
      this.inProcessToAddWishlist = false;
      this.chkd.detectChanges();
    }
  }

  private delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public onClosePopupShowMarkets(result) {
    setTimeout(() => {
      this.onBackKeyButton();
      this.containerMarkets.clear();
    }, 1200);
    if (result == 'purchaseCredit') {
      this.device.goToCustomTab('credit', 'profile');
      this.eventTracker.logEvent('x_CB_dialog', {'x_button_name ': 'purchaseCredit'});
    } else if (result == 'purchaseBook') {
      this.eventTracker.logEvent('x_CB_dialog', {'x_button_name ': 'purchaseBook'});
      this.http.marketsDirectPurchase(
        {
          productId: this.dataBook.products[0]['productId'],
          libraryTransitionType: this.purchase.subscriptionButtonState.subscriptionButtonState == subscriptionButtonStateType.getBySubscription ? this.libraryTransitionType.ignoreQuotaUseSubscriptionDiscount : this.libraryTransitionType.purchase
        }
      ).subscribe((res: any) => {
        if (res.isFinal) {
          {
            (window as any).Android.goToLibraryTabRefresh();
            this.refreshStatePurchase();
          }
        }
      }, err => this.log.logger(err, TypeShowLogInConsole.error));
    }
  }

  public logItem(name: string, obj: object) {
    let _obj = {
      ...{
        item_id: this.dataBook?.identifier,
        'audiobook-title': this.dataBook?.title
      }, ...obj
    };
    this.eventTracker.logEvent(name, _obj);
  }

  public async openMarketsDialog(_purchaseButtonAction) {
    await this.delay(800);
    this.containerMarkets.clear();
    const factory: ComponentFactory<PdpDialogMarketsComponent> = this.resolver.resolveComponentFactory(PdpDialogMarketsComponent);
    let componentRef: ComponentRef<PdpDialogMarketsComponent> = this.containerMarkets.createComponent(factory);

    this.logItem('x_btn_open_dialog_markets', {
      item_id: this.dataBook.identifier
    });
    let calculatePrice = this.dataBook.products[0]['price'];
    if (this.purchase && this.purchase.discounts && this.purchase.discounts.length > 0) {
      this.purchase.discounts.map(function (element) {
        calculatePrice -= element.discountValue;
      });
    }
    componentRef.instance.isShow = true;
    componentRef.instance.data = {
      purchaseButtonAction: _purchaseButtonAction,
      discountedPrice: calculatePrice
    };
    componentRef.instance.onClosePopup.subscribe(c => this.onClosePopupShowMarkets(c));
    this.addModalOpenedToUrl();
    this.render.setStyle(this.document.body, 'overflow', 'hidden');
    this.chkd.detectChanges();
  }

  public refreshStatePurchase() {
    this.http.post<IPurchase>(`/api/library/state/${this.id}`).subscribe(c => {
      this.purchase = c;
      this.rate = this.purchase.rating;
      this.ratoToComment = this.rate.userRate ?? 0;
      this.hasInWishlist = this.wishListService.hasAudiobookWishlist(this.productId);
      this.chkd.detectChanges();
    }, () => {
      this.rate = this.dataBook.rating;
      this.ratoToComment = this.rate.userRate ?? 0;
    });
  }

  private addModalOpenedToUrl() {
    //this.router.navigate([], {fragment: 'modalOpened'}).then();
    this.platformLocation.pushState(null, null, location.href + '#modalOpened');
  }

  private onBackKeyButton(callback?: () => {}) {
    if (this.location.path(true).includes('#modalOpened')) {
      this.location.back();
    } else
      this.initialing();

    if (callback)
      callback();
  }

  public onClickedTab(e: { title: string, enTitle: string, isActive: boolean }) {
    this.eventTracker.logEvent('x_tab_more_info_audiobook', {
      tab_title: e.enTitle,
      item_id: this.dataBook.identifier
    });
  }

  private infoEpisods() {
    if (this.dataBook.contentType == ProductTypeEnum.Podcast || this.dataBook.contentType == ProductTypeEnum.AudioSeries) {
      const genre = this.dataBook.genres.find(c => c['parentIdentifier'] != 0);
      const genreId = genre.identifier;
      const url = `/api/audiobooks/genre/${genreId}?$top=0&$inlinecount=allpages`;

      this.http.get(url).subscribe(c => {
        this.infoEpisod = {
          count: c.count,
          title: genre.name,
          genreId
        };
        this.chkd.detectChanges();
      })
    }
  }

  //#region "MODALS"
  public showDownloadPopup() {
    this.showPopupDownload = true;
    this.logItem('x_btn_popup_download_open', {});
    this.addModalOpenedToUrl();
    this.render.setStyle(this.document.body, 'overflow', 'hidden');
  }

  public showDescription() {
    this.logItem('x_btn_more_description', {
      item_id: this.dataBook.identifier
    });
    this.addModalOpenedToUrl();
    this.isShowDescription = true;
    this.render.setStyle(this.document.body, 'overflow', 'hidden');
    this.chkd.detectChanges();
  }

  public closeDescPopup(e) {
    this.isShowDescription = e;
    this.onBackKeyButton(() => this.isShowDescription = e);
  }

  public onSubmitPopupRateToComment(e) {
    this.ratoToComment = e['index'];
    this.logItem('x_btn_rate_to_audiobook_submit', {
      audiobookId: this.dataBook.audioBookId,
      rate: e['index']
    });
    this.onBackKeyButton(() => this.isShowRate = false);
    this.chkd.detectChanges();
  }

  public showPopupRateToComment(e) {
    this.ratoToComment = e['index'];
    this.isShowRate = true;
    this.addModalOpenedToUrl();
    this.logItem('x_btn_rate_to_audiobook', {});
    this.render.setStyle(this.document.body, 'overflow', 'hidden');
    this.chkd.detectChanges();
  }

  //#endregion "MODALS"
  ngOnDestroy(): void {
    this.dataBook = null;
    this.subscription.unsubscribe();
    if (this.device.isIOS() || this.device.isAndroid())
      this.router.routeReuseStrategy.shouldReuseRoute = (f, c) => false;
    this.loadComplete = false;
    if (this.pendingRequest)
      this.pendingRequest.unsubscribe();
    if (this._locationObserve)
      this._locationObserve.unsubscribe();
    if (this.stateAudiobookRequest)
      this.stateAudiobookRequest.unsubscribe();
    if (this.subscriptionParam)
      this.subscriptionParam.unsubscribe();
    this.chkd.detectChanges();
  }
}
